import axios from "axios";
import serverConfig from "@/store/server";
import store from "@/store";
import { isAccessBlocked } from "@/plugins/axiosInterceptor";

const HEARTBEAT_INTERVAL = 30000;

let heartbeatTimer = null;
let isHeartbeatActive = false;

export function startHeartbeat(onSessionExpired) {
  if (isHeartbeatActive) {
    return;
  }

  isHeartbeatActive = true;

  const checkToken = async () => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        stopHeartbeat();
        onSessionExpired();
        return;
      }

      const url = serverConfig.url + serverConfig.urls.tokenIsValid;

      const res = await axios.get(url, {
        headers: serverConfig.getHeader(),
      });

      // /tokenIsValid renvoie les flags partenaire courants. Passage par la mutation Vuex
      // et non par le localStorage : un changement de config doit atteindre les écrans
      // déjà ouverts, or le localStorage n'est pas réactif.
      if (res?.data?.data) {
        store.commit(
          "authentification/setPartnerFeatures",
          res.data.data.partnerFeatures
        );
      }
    } catch (error) {
      // Requête bloquée en amont d'admin-server : l'intercepteur prévient l'application,
      // le heartbeat n'a plus qu'à s'arrêter. Le blocage n'est ni un 401 ni le code 4.1,
      // sans cette branche le timer interrogerait le serveur toutes les 30 secondes.
      if (isAccessBlocked(error)) {
        stopHeartbeat();
        return;
      }

      if (
        error.response &&
        (error.response.status === 401 ||
          error.response.data?.data?.code === 4.1)
      ) {
        stopHeartbeat();
        onSessionExpired();
      }
    }
  };

  checkToken();

  heartbeatTimer = setInterval(checkToken, HEARTBEAT_INTERVAL);
}

export function stopHeartbeat() {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer);
    heartbeatTimer = null;
  }
  isHeartbeatActive = false;
}
